export default function photoGallery() {
  const widgetName = 'photoGallery';
  const widgetOpts = photoGalleryOpts;

  const linkedImages = false;
  const $widget = $(`#${widgetName}`);

  return saffire.widgets.cardWidget($($widget), {
    currentWidgetModuleItemID: widgetOpts.currentWidgetModuleItemID,
    scriptPath: widgetOpts.scriptPath,
    link: linkedImages ? ['all'] : [''],
    hasImages: true,
    lazyLoadImages: true,
    textOverImage: true,
    imageIsBackground: false,
    maxItemsVisible: 5,
    itemsPerPanel: 1,
    buyNowButton: false,
    moreButton: false,
    showDescription: false,
    cardWidgetLoaded: function (data, _owl, hasData) {
      if (hasData) {
        $widget.find('.card-content').remove();
      } else {
        $widget.remove();
      }
    },
  });
}
